import { useParams } from "react-router-dom";
import { DotIcon } from "lucide-react";
import { ROLES } from "../../../../config/constants";
import AdminRoute from "../../../auth/RestrictedRoute";
import BoxWrapper from "../../../../components/ui/BoxWrapper";
import { BookingSvg } from "../../../../components/ui/SideBarMenu";
import RenderTable from "../../../../components/ui/RenderTable";
import { useQueryParam } from "../../../../hooks/useQueryParam";
import { useInvoiceBookingsQuery } from "../../../../hooks/bookings/useBookingQuery";
import { formatMonthYear, pluralize } from "../../../../helpers/general";
import Pagination from "../../../../components/ui/Pagination";
import BookingTable from "../../bookings/BookingTable";
import { general } from "../../../../locales/general";
import MoneyIcon from "../../../../components/icons/taxiStatsIcons/MoneyIcon";
import PercentIcon from "../../../../components/icons/taxiStatsIcons/PercentIcon";
import WalletIcon from "../../../../components/icons/taxiStatsIcons/WalletIcon";
import { CardStatistics } from "../new/NewInvoicePage";

const PAGE_SIZE = 10;

export function InvoiceDetailsPage() {
  const params: Readonly<{
    invoiceId?: string;
  }> = useParams();
  const { add } = useQueryParam();

  const { invoice, bookings, isLoading, totalPages, totalItems, currentPage } =
    useInvoiceBookingsQuery(params.invoiceId as string);

  return (
    <AdminRoute route={ROLES.PLACE_ADMIN} requireMultiPlaceAdmin={true}>
      {isLoading ? (
        <div>Chargement...</div>
      ) : (
        <>
          <div className="d-flex justify-content-between items-center">
            <div className="d-flex flex-col">
              <h5 className="fs-4 fw-bold mb-2">Nouvelle facture</h5>
              <div>
                Date de fature:{" "}
                <span className="font-semibold">
                  {formatMonthYear(invoice?.month, invoice?.year)}
                </span>{" "}
                <DotIcon /> Partenaire:{" "}
                <span className="font-semibold">
                  {invoice.createdFor.fullName}
                </span>
              </div>
            </div>
          </div>
          <div className="pt-4 row">
            <CardStatistics
              title="Revenu"
              total={invoice?.total ?? 0}
              icon={
                (
                  <MoneyIcon width="48" height="48" className="text-danger" />
                ) as React.ReactNode
              }
              borderColor="border-danger"
              iconBgColor="bg-danger"
            />
            <CardStatistics
              title={`Commission hôtelière`}
              total={invoice?.partnerCommission ?? 0}
              icon={
                (
                  <PercentIcon
                    width="48"
                    height="48"
                    className="text-primary"
                  />
                ) as React.ReactNode
              }
              borderColor="border-primary"
              iconBgColor="bg-primary"
            />
            <CardStatistics
              title="Vous"
              total={invoice?.placeTotal ?? 0}
              icon={
                (
                  <WalletIcon width="48" height="48" className="text-success" />
                ) as React.ReactNode
              }
              borderColor="border-success"
              iconBgColor="bg-success"
            />
          </div>
          <BoxWrapper>
            <div className="d-flex  justify-content-between align-items-baseline before-table">
              <div className="d-flex align-items-center gap-2 p-3 delete-add"></div>
              <div className="d-flex flex-column-reverse flex-md-row  justify-content-end">
                <div className="d-flex align-items-center justify-content-between">
                  <div
                    className="d-flex align-items-center justify-content-center gap-3 bg-gradient-primary p-3 w-100"
                    style={{ borderTopRightRadius: "8px" }}
                  >
                    <BookingSvg />
                    <p className="fs-5 fw-bold m-0  text-white">
                      {totalItems} {pluralize("Réservation", totalItems)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <RenderTable
              loading={isLoading}
              render={() =>
                bookings?.length > 0 ? (
                  <BookingTable bookings={bookings} />
                ) : (
                  <p className="text-center fs-5 my-2">{general.fr.noData}</p>
                )
              }
            />
          </BoxWrapper>
          <Pagination
            currentPage={Number(currentPage)}
            onPageChange={(page) => {
              add("page", page.toString());
            }}
            siblingCount={1}
            totalCount={totalPages}
            pageSize={PAGE_SIZE}
          />
        </>
      )}
    </AdminRoute>
  );
}
